import React, { useRef } from 'react';
import Modal from '@/components/modals';
import CloseIcon from '../icons/CloseIcon';
import useHandleOutSide from '@/hooks/useHandleOutSide';
import UseLocale from '@/hooks/useLocale';

const TamaraModal = ({ show, setShow, total, numberOfInstallments }) => {
  const ref = useRef();
  const { locale, store } = UseLocale();
  console.log('locale', locale);
  useHandleOutSide(ref, () => setShow(false));
  return (
    <Modal show={show} isCenter>
      <div
        ref={ref}
        className='fixed left-1/2 top-1/2 z-50 h-[80vh] w-[90vw] -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-3xl bg-white shadow-lg md:h-[614px] md:w-8/12'
      >
        <CloseIcon
          onClick={() => setShow(false)}
          className='absolute start-4 top-4 size-14'
        />
        <iframe
          width='100%'
          height='100%'
          loading='lazy'
          src={`https://cdn.tamara.co/widget/tamara-introduction.html?lang=${locale === 'ar' ? 'ar' : 'en'}&price=${total}&currency=${store === 'ksa' ? 'SAR' : 'AED'}&countryCode=${store === 'ksa' ? 'SA' : 'AE'}&colorType=default&showBorder=true&paymentType=installment&numberOfInstallments=${numberOfInstallments}&disableInstallment=false&disablePaylater=true&widgetType=product-widget`}
        ></iframe>
      </div>
    </Modal>
  );
};

export default TamaraModal;
